export default __webpack_public_path__ + "static/media/Notificacao.5a353ae8.svg";